import { axiosInstance } from './axiosInstance';
import axios from 'axios';



export const list = async (db) => {
    try {
        const response = await axiosInstance.get('/api/v1/adminpanel/user/health-check');
        return response;
    } catch (error) {
        throw error.response || error;
    }
};



